'use client';

import { useSyncExternalStore } from 'react';

const subscribeNever = () => () => undefined;
const getPageOrigin = () => window.location.origin;
const getServerPageOrigin = () => null;

export function usePageOrigin(): string | null {
  return useSyncExternalStore(
    subscribeNever,
    getPageOrigin,
    getServerPageOrigin
  );
}
